import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { PAGE_SIZE } from '../constants.ts';
import PhotosSearchBrowseSocialIcons from './PhotosSearchBrowseSocialIcons.tsx';
import PhotosSearchBrowsePhotoPreviewPhotoSwiper from './PhotosSearchBrowsePhotoPreviewPhotoSwiper.tsx';

import { type PhotosSearchBrowsePhotoContainerMobile_photos$key } from './__generated__/PhotosSearchBrowsePhotoContainerMobile_photos.graphql.ts';

import { type FacetFilter } from '../helpers/useFacetReducer.ts';

type Props = {
    facetFilter: FacetFilter;
    photos: PhotosSearchBrowsePhotoContainerMobile_photos$key | null | undefined;
    modalPhotoIndex: number;
    currentPhotoIndex: number;
    totalResults: number;
    changePhotoIndex: ({ direction }: { direction: 'prev' | 'next' }) => void;
    userId: string;
};

const PhotosSearchBrowsePhotoContainerMobile: FC<Props> = ({
    facetFilter,
    photos: photosRef,
    modalPhotoIndex,
    totalResults,
    currentPhotoIndex,
    changePhotoIndex,
    userId,
}) => {
    const photos = useFragment(
        graphql`
            fragment PhotosSearchBrowsePhotoContainerMobile_photos on PhotosSearchBrowseQueryConnection {
                ...PhotosSearchBrowseSocialIcons_photos
                ...PhotosSearchBrowsePhotoPreviewPhotoSwiper_photos
                edges {
                    node {
                        ...PhotosSearchBrowseSocialIcons_photo
                        id
                        serviceId
                        path
                        url
                        name
                        width
                        height
                        styles {
                            name
                        }
                        room {
                            name
                        }
                    }
                }
            }
        `,
        photosRef
    );

    const photoEdges = photos?.edges || [];
    const photoNode = photoEdges[modalPhotoIndex]?.node || null;

    return (
        <>
            <PhotosSearchBrowsePhotoPreviewPhotoSwiper
                photos={photos}
                currentPhotoIndex={currentPhotoIndex}
                page={facetFilter.page}
                itemsOnPage={facetFilter.first ?? PAGE_SIZE}
                totalResults={totalResults}
                modalPhotoIndex={modalPhotoIndex}
                changePhotoIndex={changePhotoIndex}
            />
            <PhotosSearchBrowseSocialIcons photo={photoNode} photos={photos} userId={userId} />
        </>
    );
};

export default PhotosSearchBrowsePhotoContainerMobile;
